import { Box, Stack, styled, Typography } from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
interface Props {}

const CancelIconContainer = styled('div')`
  width: 96px;
  height: 96px;
  display: flex;
  justify-content: center;
  align-items: center;

  .cancel_icon {
    transform: scale(4);
  }
  svg {
    fill: #d13e43;
  }
`

export function PageNotFound(props: Props) {
  return (
    <Stack
      width={'100%'}
      height={'100%'}
      justifyContent={'center'}
      alignItems={'center'}
      textAlign={'center'}
    >
      <Box display={'flex'} alignItems={'center'}>
        <Typography fontWeight={'500'} fontSize={'94px'} color="#d13e43">
          404
        </Typography>
        <CancelIconContainer>
          <CancelIcon className="cancel_icon" />
        </CancelIconContainer>
      </Box>
      <Typography fontSize={'34px'}>
        Sorry, the page you were searching, was not found
      </Typography>
    </Stack>
  )
}
